// Bootstraping dependencies
require('./bootstrap');

// Loading app components
require('./partials/globalFunctions.js')
require('./partials/ajaxDownload')
require('./partials/popoverConfirm')
require('./partials/datePicker')
require('./partials/generateurEcheancier');
